export const IPushNotificationScreenViewModelType = Symbol('IPushNotificationScreenViewModel');
